/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../contexts/aniplus";
import { withRouter } from "react-router-dom";

class StarCommentItem extends Component {
  state = {
    view: false,
  };
  _onToggleView = () => {
    const { view } = this.state;

    this.setState({
      view: !view,
    });
  };
  _onDel = () => {
    const { idx, onDel } = this.props.childProps;
    onDel(idx);
  };
  render() {
    // const { view } = this.state;
    const { userid, nicName, charac_img, content, regDate, contentValue } =
      this.props.childProps;
    const { loginId } = this.props;
    return (
      <Fragment>
        <dl>
          <dt>
            <span>
              <img src={charac_img} />
            </span>
          </dt>
          <dd>
            <h2>
              {nicName}{" "}
              <div className="star_img_bg4">
                <div
                  className="star_img_bg4_on"
                  style={{ width: contentValue * 10 - 15 + "%" }}
                ></div>
                {contentValue}
              </div>
              {loginId === userid ? (
                <span style={{ cursor: "pointer" }} onClick={this._onDel}>
                  내리뷰
                </span>
              ) : null}
            </h2>
            <p>{content}</p>
            <em>{regDate}</em>
          </dd>
        </dl>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(StarCommentItem));
